"use client";
import React, { useState } from 'react';
import {
    Popover,
    Box,
    List,
    ListItem,
    ListItemText,
    Button,
    useTheme,
    useMediaQuery,
    ListItemIcon,
    Radio,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { sortOptions } from './sortOptions';
import { useFilters } from 'app/providers/filters-provider';

const SortPopover = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const [anchorEl, setAnchorEl] = useState(null);
    const { filters, setFilters } = useFilters();

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSortSelect = (sortValue) => {
        setFilters(prev => ({ ...prev, sort: prev.sort || sortValue }));
        handleClose();
    };

    // Hide on mobile as sort options are in FiltersPopover
    if (isMobile) {
        return null;
    }

    return (
        <>
            <Button
                onClick={handleClick}
                endIcon={<KeyboardArrowDownIcon />}
                sx={{
                    color: 'var(--theme-dark, #2B4D59)',
                    textTransform: 'none',
                    fontSize: '14px',
                    '&:hover': {
                        backgroundColor: 'rgba(43, 77, 89, 0.04)'
                    },
                    '& .MuiButton-endIcon': {
                        marginLeft: '2px',
                    }
                }}
            >
                Sort by
            </Button>
            <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                PaperProps={{
                    elevation: 8,
                    sx: {
                        width: isMobile ? 'calc(100% - 32px)' : '220px',
                        maxWidth: isMobile ? 'calc(100% - 32px)' : '220px',
                        bgcolor: '#fff',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                        borderRadius: '4px',
                        overflow: 'hidden',
                        margin: isMobile ? '0 16px' : 0,
                    }
                }}
            >
                <List sx={{ p: 0 }}>
                    {sortOptions.map((option) => (
                        <ListItem
                            key={option.value}
                            button
                            onClick={() => handleSortSelect(option.value)}
                            sx={{
                                py: 1,
                                px: 2,
                                '&:hover': {
                                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                                }
                            }}
                        >
                            <ListItemIcon sx={{ minWidth: '32px' }}>
                                <Radio
                                    checked={filters.sort === option.value}
                                    size="small"
                                    sx={{
                                        color: 'rgba(43, 77, 89, 0.4)',
                                        '&.Mui-checked': {
                                            color: 'var(--theme-dark, #2B4D59)',
                                        }
                                    }}
                                />
                            </ListItemIcon>
                            <ListItemText 
                                primary={option.label}
                                primaryTypographyProps={{
                                    fontSize: '14px',
                                    color: '#000'
                                }}
                            />
                        </ListItem>
                    ))}
                </List>
            </Popover>
        </>
    );
};

export default SortPopover; 